import { apiClient } from "../../../lib";
import { CommercialsDashboardData } from "../types";

export const commercialsDashboard = {

    fetch: async (): Promise<CommercialsDashboardData> => {
        const response = await apiClient.get("/programme/financial-performance");
        return response.data.data;
    },

    fetchCommercialData: async ({ page, limit, type }: { page: number, limit: number, type?: string }): Promise<any> => {
        const response = await apiClient.get(`/projects/commercial-data`, { params: { page, limit, type } });
        return response.data.data;
    }

};